// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error-modal_wrapper__STFac","errorItem":"error-modal_errorItem__74MsA","validationErrorTitle":"error-modal_validationErrorTitle__EzrWa"};